import React from "react";

const GlobalProgressOverlay = ({ progress }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <div className="loading-title">Obrada u toku...</div>
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="progress-text">{progress}%</div>
      </div>
    </div>
  );
};

export default GlobalProgressOverlay;
